import React from 'react';
import {Navbar, Container, Dropdown, Nav, NavDropdown} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {useAuth} from '../context/auth.context';
import {hasRole} from "../../service/utils/accessUtils";

export default function Header() {
    const {isLoggedIn, setIsLoggedIn, logout, isLoggedOrg} = useAuth();
    const handleLogout = () => {
        logout();
        setIsLoggedIn(false);
    };
    const logo = isLoggedOrg('M4') ? "/logo.png" : "/rc_png_b.png"; // Ruta a tu logo
    return (
        <>
            {isLoggedIn && (
                <Navbar bg="dark" variant="dark" expand="lg">
                    <Container fluid className="px-5">
                        <Navbar.Brand as={Link} to="/">
                            <img
                                src={logo}
                                height="50"
                                width="100"
                                alt="Mi Aplicación"
                                className="d-inline-block align-top"
                            />
                        </Navbar.Brand>

                        {/* Botón responsive */}
                        <Navbar.Toggle aria-controls="navbar-nav"/>
                        <Navbar.Collapse id="navbar-nav">
                            {/* Pestañas de navegación */}
                            <Nav className="me-auto">
                                {isLoggedOrg("M4") && <>
                                    {hasRole("ADMIN") &&
                                        <NavDropdown title="Predio Programa" id="nav-programa" menuVariant="dark">
                                            <NavDropdown.Item as={Link} to="/m4/users">
                                                Ver Trabajadores
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/m4/predios">
                                                Ver Predios
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/m4/localidades">
                                                Ver Localidades
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/m4/programa/create">
                                                Crear Programa
                                            </NavDropdown.Item>
                                            <NavDropdown.Item as={Link} to="/m4/programa/historico">
                                                Historico Programas
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    }
                                    <NavDropdown title="Lista Control" id="nav-programa" menuVariant="dark">
                                        { hasRole("ADMIN") &&
                                            <NavDropdown.Item as={Link} to="/m4/form/create">
                                                Crear Lista Control
                                            </NavDropdown.Item>
                                        }
                                        <NavDropdown.Item as={Link} to="/m4/form/list">
                                            Ver Listas de Control
                                        </NavDropdown.Item>
                                    </NavDropdown>

                                    <NavDropdown title="Cursos" id="nav-cursos" menuVariant="dark">
                                        {hasRole("ADMIN") &&
                                            <NavDropdown.Item as={Link} to="/m4/cursos/admin">
                                                Administrar Cursos
                                            </NavDropdown.Item>
                                        }
                                        <NavDropdown.Item as={Link} to="/m4/cursos/mis-cursos">
                                            Mis Cursos
                                        </NavDropdown.Item>
                                        {hasRole("ADMIN") &&
                                            <NavDropdown.Item as={Link} to="/m4/cursos-externos/admin">
                                                Administrar Cursos Externos
                                            </NavDropdown.Item>
                                        }
                                        <NavDropdown.Item as={Link} to="/m4/cursos-externos/mis-cursos-externos">
                                            Mis Cursos Externos
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>}
                                {isLoggedOrg("M4") && hasRole("ADMIN") &&
                                    <NavDropdown title="Control Usuarios" id="nav-manage-users" menuVariant="dark">
                                        <NavDropdown.Item as={Link} to="/users/register">
                                            Creacion rapida
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/users/create">
                                            Crear Trabajador
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/users/view">
                                            Ver Trabajador
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/users/table">
                                            Ver Lista Trabajadores
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/users/roles">
                                            Actualizar Permisos
                                        </NavDropdown.Item>
                                        {/*<NavDropdown.Item as={Link} to="/organizations">
                                            Organizaciones
                                        </NavDropdown.Item>*/}
                                    </NavDropdown>}
                                {isLoggedOrg("ARAUCO") && <>
                                    <NavDropdown title="Formularios" id="nav-programa" menuVariant="dark">
                                        {/*
                    <NavDropdown.Item as={Link} to="/arauco/form/create">
                      Crear Formulario
                    </NavDropdown.Item>
                    */}
                                        <NavDropdown.Item as={Link} to="/arauco/form/list">
                                            Ver Formularios
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                    <NavDropdown title="Lista de Distribucion" id="nav-programa" menuVariant="dark">
                                        <NavDropdown.Item as={Link} to="/arauco/distribution/create">
                                            Crear Lista Distribución
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/arauco/distribution/view">
                                            Ver Listas de Distribución
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                    <NavDropdown title="Usuarios Básicos" id="nav-programa" menuVariant="dark">
                                        <NavDropdown.Item as={Link} to="/arauco/user/create">
                                            Crear Trabajador
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/arauco/user/view">
                                            Ver Trabajador
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>}
                            </Nav>
                            {/* Menú de usuario a la derecha */}
                            <Dropdown className="ms-auto">
                                <Dropdown.Toggle
                                    variant="dark"
                                    id="dropdown-user"
                                    className="border-0"
                                >
                                    <i
                                        className="bi bi-person-circle"
                                        style={{fontSize: "1.8rem", color: "white"}}
                                    ></i>
                                </Dropdown.Toggle>

                                <Dropdown.Menu align="end">
                                    <Dropdown.Item as={Link} to="/perfil">Mi Perfil</Dropdown.Item>
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            )}
        </>
    );
}